import { Outlet, NavLink } from "react-router-dom";

import logo from './Img/donuts paradise.png'
import React, { useState } from 'react';
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBIcon,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse,
} from 'mdb-react-ui-kit';

export default function Navbar() {
    const [openBasic, setOpenBasic] = useState(false);

    return (
        <>
            <MDBNavbar sticky expand='md' light bgColor='light'>
                <MDBContainer fluid>
                    <MDBNavbarBrand>
                        <img
                            src={logo}
                            height='60'
                            alt=''
                            loading='lazy'
                        />
                        <NavLink to="/" className={"nav-link active"}>donuts paradise</NavLink>
                    </MDBNavbarBrand>

                    <MDBNavbarToggler
                        aria-controls='navbarSupportedContent'
                        aria-expanded='false'
                        aria-label='Toggle navigation'
                        onClick={() => setOpenBasic(!openBasic)}
                    >
                        <MDBIcon icon='bars' fas />
                    </MDBNavbarToggler>

                    <MDBCollapse navbar open={openBasic}>
                        <MDBNavbarNav className='mr-auto'>
                            <MDBNavbarItem>
                                <MDBNavbarLink>
                                    <NavLink to="/Mapa" className={"nav-link active"}>Map </NavLink>
                                </MDBNavbarLink>
                            </MDBNavbarItem>

                        </MDBNavbarNav>
                        <a className='fw-bold' href='https://www.instagram.com/donuts_paradisel/'>instagram:donuts_paradisel</a>
                        <MDBNavbarLink href='https://www.instagram.com/donuts_paradisel/'>
                            <MDBIcon className='m-2' fab icon="instagram" size='lg' />
                        </MDBNavbarLink>
                    </MDBCollapse>
                </MDBContainer>
            </MDBNavbar>
            <Outlet />
        </>
    );
}